// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"b2ec1726","413":"3d3bdac8"}[chunkId] + ".chunk.css";
};